import { createTheme } from "@mui/material/styles";
import {
  ERROR_COLOR,
  GRAY_COLOR,
  LIGHT_GRAY_COLOR,
  PRIMARY_COLOR,
  SECONDARY_COLOR,
  SUCCESS_COLOR,
  WARNING_COLOR,
  WHITE_COLOR,
} from "utility/colors";

const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: PRIMARY_COLOR,
      contrastText: WHITE_COLOR,
    },
    secondary: {
      main: SECONDARY_COLOR,
      contrastText: WHITE_COLOR,
    },
    white: {
      main: "#fff",
      contrastText: "#000000de",
    },
    success: {
      main: SUCCESS_COLOR,
      contrastText: WHITE_COLOR,
    },
    warning: {
      main: WARNING_COLOR,
      contrastText: WHITE_COLOR,
    },
    error: {
      main: ERROR_COLOR,
      contrastText: WHITE_COLOR,
    },
  },
  typography: {
    // In Chinese and Japanese the characters are usually larger,
    // so a smaller fontsize may be appropriate.
    fontSize: 12,
    fontFamily: ["Poppins-Regular"],

    h3: {
      fontSize: 50,
      fontWeight: 600,
      color: SECONDARY_COLOR,
    },
    h4: {
      fontSize: 30,
    },
    h5: {
      fontSize: 20,
    },
    h6: {
      fontSize: 18,
    },
    body1: {
      fontSize: 12,
      color: GRAY_COLOR,
    },
    body2: {
      fontSize: 14,
      color: LIGHT_GRAY_COLOR,
    },
    custom13: {
      fontSize: 13,
    },
    caption: {
      fontSize: 10,
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 640,
      md: 768,
      lg: 1024,
      xl: 1280,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { textTransform: "capitalize" },
        // sizeLarge: {
        //   padding: "15px 22px",
        //   fontSize: 14,
        // },
      },
    },
    MuiTimelineItem: {
      styleOverrides: {
        root: {
          "&.MuiTimelineItem-missingOppositeContent": {
            "&:before": {
              display: "none",
            },
          },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          color: GRAY_COLOR,
          "&::placeholder": {
            color: GRAY_COLOR,
          },
        },
      },
    },
    // MuiBackdrop: {
    //   styleOverrides: {
    //     root: {
    //       backdropFilter: "blur(5px)",
    //       background: TRANSPARENT_WHITE_COLOR,
    //     },
    //   },
    // },
  },
});

export default lightTheme;
